import { decorate, observable, action } from "mobx";
import React from "react";

export default class ModalHandler {
  constructor(component) {
    this.rootStore = null; // will be initialized by addPageHandlers

    if (!component instanceof React.Component) {
      throw new Error("component should be of type React.Component");
    }

    this.component = component;
    this.title = null;
    this.glyph = null;
    this.props = {};
    this.modalProps = {
      backdrop: "static"
    };
  }

  close() {
    this.rootStore.ui.modals.closeCurrentModal();
  }
}

decorate(ModalHandler, {
  title: observable,
  glyph: observable,
  close: action
});



// WEBPACK FOOTER //
// ./src/Core/Stores/ModalsStore/ModalHandler.js